import { useQuery } from '@tanstack/react-query';
import { getAgencyAccountById } from '../../../../../agencies/AgencyService';
import { getData } from '../../../../../utils/functional/fp';

const useGetAgencyDetails = (id: string | undefined) => {
  return useQuery({
    queryKey: ['agency-details', id],
    queryFn: () => getAgencyAccountById(id as string).then(getData),
    enabled: Boolean(id),
  });
};

export default useGetAgencyDetails;
